import { http } from '../../utils/http'
export const UABASE = window.$envUtils('VUE_APP_AFF_SERVICE')

// 工单集合查询
export const getOrderLogList = (data) => {
  return http.post(`${UABASE}/nissan/queryOrderLog`, { data })
}

export const exportForm = (params) => {
  return http.get(`${UABASE}/manager/nissan/exportForm`, { params, responseType: 'blob' })
}
// 工单导出
export const exportOrderLog = (data) => {
  return http.post(`${UABASE}/nissan/exportOrderLog`, { data, responseType: 'blob' })
}
